<template>
  <v-sheet tile color="#ffffff" >
    <v-container>
      <div class="title">Confirm Email</div>
      <br/>
      <div>
        <v-form v-model="isValid">
          <v-text-field background-color="#F4F7FC" filled light required v-model="code" label="Code" @input="resetError"
                        autocomplete="one-time-code" :rules="[v => !!v || 'Code is required']" ref="code_field"
                        type="numeric" name="code"/>
        </v-form>
      </div>
      <br/>
      <div class="error pa-2 white--text rounded" v-if="error">
        {{ error }}
      </div>
      <br/>
      <div class="buttons-container">
        <v-btn color="primary" v-on:click="confirm" :disabled="!isValid">Confirm</v-btn>
        <v-btn color="primary" v-on:click="resend">Resend Code</v-btn>
        <v-btn color="primary" v-on:click="signIn">Back to Sign In</v-btn>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
  import {AmplifyEventBus} from 'aws-amplify-vue';

  export default {
    name: 'ConfirmSignUp',
    props: ['user'],
    data() {
      return {
        code: '',
        error: '',
        isValid: false
      }
    },
    mounted: function () {
      if (!this.user.username) {
        return this.setError('Valid username not received.');
      }
    },
    methods: {
      resetError: function () {
        this.error = ''
      },
      confirm() {
        this.$Amplify.Auth.confirmSignUp(this.user.username, this.code)
          .then(() => {
            AmplifyEventBus.$emit('authState', 'signedOut')
          })
          .catch(e => this.setError(e));
      },
      resend() {
        this.$Amplify.Auth.resendSignUp(this.user.username)
          .then(() => {
          })
          .catch(e => this.setError(e));
      },
      signIn() {
        AmplifyEventBus.$emit('authState', 'signedOut')
      },
      setError(e) {
        this.error = e.message || e;
      }
    }
  }
</script>
<style lang="scss" scoped>
  .buttons-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 1rem;
    grid-row-gap: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/Auth/ConfirmSignUp.vue